module.exports = __webpack_public_path__ + "img/3.49441df7.png";